import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import routes from './router'
import Router from 'vue-router'
import {get,post} from '../store/vue_resource'
import {hasBtn,removeByIndex,getTime,router_url,effect_list,api_imgurl,parts,expiry_time,screenHeight,secondsToMinutesAndHours} from '../store/store'
import upload from '@/components/upload.vue'
import EditorBar from '@/components/wangEnduit.vue'
import JsonExcel from 'vue-json-excel'
import json_data from '@/components/json_data.vue'
Vue.component('downloadExcel', JsonExcel)
Vue.component('upload', upload)
Vue.component('EditorBar', EditorBar)
Vue.component('json_data', json_data)

import FileSaver from 'file-saver'
import * as XLSX from '@/../static/js/xlsx.mjs'
import echarts from 'echarts'
Vue.prototype.FileSaver = FileSaver
Vue.prototype.XLSX = XLSX
Vue.prototype.$echarts = echarts
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import VueResource from 'vue-resource'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import html2canvas from "html2canvas"
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.table_height = screenHeight()
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.effect_list = effect_list
Vue.prototype.api_imgurl = api_imgurl
Vue.prototype.$parts = parts
Vue.prototype.$html2canvas = html2canvas
Vue.prototype.expiry_time = expiry_time
Vue.prototype.secondsToMinutesAndHours = secondsToMinutesAndHours
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(GeminiScrollbar)
Vue.use(VueResource)
// Vue.use(upload)
Vue.component(CollapseTransition.name, CollapseTransition)

import Lodop from '@/../static/js/lodop/LodopFuncs';
Vue.use(Lodop)

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
		sessionStorage.removeItem('token');
	};
	let token = sessionStorage.getItem('token');
	if (!token && to.path != '/login') {
		next({
			path: '/login'
		})
	} else if (to.path == '/') {
		next({
			path: '/index'
		})
	} else {
		next()
	}
})


new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js